export enum SectionType {
  indexAPY = "indexAPY",
  indexInfo = "indexInfo",
  withdrawSchedule = "withdrawSchedule",
  analytics = "analytics",
  vaultInfo = "vaultInfo",
}
